import React, { useEffect } from "react";
import cl from "./Cokie.module.css";
import { animateScroll as scroll } from "react-scroll";

const Cokie = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Cookie Policy per {props.shopName}</h1>
      <p>Ultimo aggiornamento: 07 febbraio 2024</p>

      <h4>Tecnologie di Tracciamento e Cookie</h4>
      <p>
        Utilizziamo i Cookie e tecnologie di tracciamento simili per monitorare
        l'attività sul Nostro Servizio e memorizzare determinate informazioni.
        Le tecnologie di tracciamento utilizzate possono essere beacon, tag e
        script per raccogliere e tracciare informazioni e per migliorare e
        analizzare il Nostro Servizio. Le tecnologie che utilizziamo possono
        includere:
      </p>
      <ul style={{marginLeft: '30px'}}>
        <li style={{marginBottom: '10px'}}>
          <strong>Cookies o Cookie del Browser.</strong> Un cookie è un piccolo
          file posizionato sul Tuo Dispositivo. Puoi istruire il Tuo browser a
          rifiutare tutti i Cookie o a indicare quando viene inviato un Cookie.
          Tuttavia, se non accetti i Cookie, potresti non essere in grado di
          utilizzare alcune parti del nostro Servizio. A meno che tu non abbia
          modificato le impostazioni del Tuo browser in modo che rifiuti i
          Cookie, il nostro Servizio potrebbe utilizzare i Cookie.
        </li>
        <li>
          <strong>Beacon Web.</strong> Alcune sezioni del nostro Servizio e
          delle nostre e-mail possono contenere piccoli file elettronici noti
          come beacon web (anche chiamati gif trasparenti, tag pixel e gif pixel
          singoli) che consentono alla Società, ad esempio, di contare gli
          utenti che hanno visitato quelle pagine o aperto un'e-mail e per altre
          statistiche relative al sito web (ad esempio, registrare la popolarità
          di una determinata sezione e verificare l'integrità del sistema e del
          server).
        </li>
      </ul>
      <p>
        I Cookie possono essere "Persistenti" o "di Sessione". I Cookie
        Persistenti rimangono sul Tuo computer personale o dispositivo mobile
        quando vai offline, mentre i Cookie di Sessione vengono eliminati non
        appena chiudi il Tuo browser web. Puoi saperne di più sui cookie su
        {props.shopName} articolo.
      </p>
      <p>
        Utilizziamo sia Cookie di Sessione che Persistenti per i fini di
        seguito:
      </p>
      <ul style={{marginLeft: '30px'}}>
        <li>
          <p>
            <strong>Cookies Necessari / Essenziali</strong>
          </p>
          <p>Tipo: Cookie di Sessione</p>
          <p>Amministrati da: Noi</p>
          <p>
            Scopo: Questi Cookie sono essenziali per fornirti i servizi
            disponibili tramite il Sito Web e per consentirti di utilizzare
            alcune delle sue funzionalità. Aiutano ad autenticare gli utenti e a
            prevenire un uso fraudolento degli account utente. Senza questi
            Cookie, i servizi che hai richiesto non possono essere forniti e
            utilizziamo questi Cookie solo per fornirti quei servizi.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies Policy / Notice Acceptance Cookies</strong>
          </p>
          <p>Tipo: Cookie Persistenti</p>
          <p>Amministrati da: Noi</p>
          <p>
            Scopo: Questi Cookie identificano se gli utenti hanno accettato
            l'uso di cookie sul Sito Web.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies di Funzionalità</strong>
          </p>
          <p>Tipo: Cookie Persistenti</p>
          <p>Amministrati da: Noi</p>
          <p>
            Scopo: Questi Cookie ci consentono di ricordare le scelte che fai
            quando utilizzi il Sito Web, come ad esempio ricordare i tuoi
            dettagli di accesso o le tue preferenze linguistiche. Lo scopo di
            questi Cookie è fornirti un' esperienza più personale e evitare che
            tu debba reinserire le tue preferenze ogni volta che utilizzi il
            Sito Web.
          </p>
        </li>
      </ul>
      <p>
        Per ulteriori informazioni sui cookie che utilizziamo e sulle tue scelte
        relative ai cookie, visita la nostra Politica sui Cookie o la sezione
        Cookie della nostra Informativa sulla Privacy.
      </p>
      <p>
        Tuttavia, se stai ancora cercando ulteriori informazioni, puoi
        contattarci tramite uno dei nostri metodi di contatto preferiti:
      </p>

      <ul style={{marginLeft: '30px'}}>
        <li>Email: supporto@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Cokie;
